<div nz-row [nzGutter]="[16, 6]">
	<div nz-col nzSpan="12">
		<nz-card nzTitle="{{ 'ui.showcase.pureButton' | translate }}">
			<div nz-row [nzGutter]="[16, 6]">

				<div nz-col nzSpan="8">
					<app-splitbutton [elements]="[singleButtonElementPrimaryNoIcon]"></app-splitbutton>
				</div>

				<div nz-col nzSpan="8">
					<app-splitbutton [elements]="[singleButtonElementSecondaryNoIcon]"></app-splitbutton>
				</div>

				<div nz-col nzSpan="8">
					<app-splitbutton [burgerMenu]="true" [elements]="[singleButtonElementPrimaryNoIcon]"></app-splitbutton>
				</div>

			</div>
			<nz-divider></nz-divider>
			Standard Button, ohne Icon. Entsteht wenn der Splitbutton nur ein einzelnes Element ohne icon enthält.
			<nz-divider></nz-divider>
			Optionen:
			<ul>
				<li>
					HTML:<br> <code ngNonBindable>&lt;app-splitbutton [elements]="[singleButtonElementPrimaryNoIcon]">&lt;/app-splitbutton></code>
				</li>
				<li>
					Komponente:<br> <code ngNonBindable>singleButtonElementPrimaryNoIcon: SplitButtonElement = &#123;title: 'ui.showcase.primary', type:
					'primary'&#125;;</code>
				</li>
			</ul>
		</nz-card>
	</div>

	<div nz-col nzSpan="12">
		<nz-card nzTitle="{{ 'ui.showcase.buttonIcon' | translate }}">
			<div nz-row [nzGutter]="[16, 6]">

				<div nz-col nzSpan="8">
					<app-splitbutton [elements]="[singleButtonElementPrimaryIcon]"></app-splitbutton>
				</div>

				<div nz-col nzSpan="8">
					<app-splitbutton [elements]="[singleButtonElementSecondaryIcon]"></app-splitbutton>
				</div>

				<div nz-col nzSpan="8">
					<app-splitbutton [burgerMenu]="true" [elements]="[singleButtonElementPrimaryIcon]"></app-splitbutton>
				</div>

			</div>
			<nz-divider></nz-divider>
			Standard Button mit Icon. Entsteht wenn der Splitbutton nur ein einzelnes Element mit icon enthält.
			<nz-divider></nz-divider>
			Optionen:
			<ul>
				<li>
					HTML:<br> <code ngNonBindable>&lt;app-splitbutton [elements]="[singleButtonElementPrimaryIcon]">&lt;/app-splitbutton></code>
				</li>
				<li>
					Komponente:<br> <code ngNonBindable>singleButtonElementPrimaryIcon: SplitButtonElement = &#123;title: 'ui.showcase.primary', type:
					'primary', icon: 'edit'&#125;;</code>
				</li>
			</ul>
		</nz-card>
	</div>

	<div nz-col nzSpan="12">
		<nz-card nzTitle="Splitbuttons">
			<div nz-row [nzGutter]="[16, 6]">

				<div nz-col nzSpan="8">
					<app-splitbutton [elements]="[singleButtonElementPrimaryNoIcon, singleButtonElementPrimaryIcon]"></app-splitbutton>
				</div>

				<div nz-col nzSpan="8">
					<app-splitbutton [elements]="[singleButtonElementSecondaryNoIcon, singleButtonElementSecondaryIcon]"></app-splitbutton>
				</div>

				<div nz-col nzSpan="8">
					<app-splitbutton [burgerMenu]="true" [elements]="[singleButtonElementPrimaryNoIcon, singleButtonElementPrimaryIcon]"></app-splitbutton>
				</div>

			</div>
			<nz-divider></nz-divider>
			Splitbutton mit Burgermenü und ohne Icon. Entsteht wenn der Splitbutton über mehr als ein Element verfügt, das erste aber kein Icon hat.
			<nz-divider></nz-divider>
			Optionen:
			<ul>
				<li>
					HTML:<br> <code ngNonBindable>&lt;app-splitbutton [elements]="[singleButtonElementPrimaryNoIcon, singleButtonElementPrimaryIcon]">&lt;
					/app-splitbutton></code>
				</li>
				<li>
					Komponente:<br> <code ngNonBindable>singleButtonElementPrimaryNoIcon: SplitButtonElement = &#123;title: 'ui.showcase.primary', type:
					'primary'&#125;;</code><br><br>
					<code ngNonBindable>singleButtonElementPrimaryIcon: SplitButtonElement = &#123;title: 'ui.showcase.primary', type: 'primary', icon:
						'edit'&#125;;</code>
				</li>
			</ul>
		</nz-card>
	</div>

	<div nz-col nzSpan="12">
		<nz-card nzTitle="{{ 'ui.showcase.splitbuttonIcon' | translate }}">
			<div nz-row [nzGutter]="[16, 6]">

				<div nz-col nzSpan="8">
					<app-splitbutton [elements]="[singleButtonElementPrimaryIcon, singleButtonElementSecondaryIcon]"></app-splitbutton>
				</div>

				<div nz-col nzSpan="8">
					<app-splitbutton [elements]="[singleButtonElementSecondaryIcon, singleButtonElementPrimaryIcon]"></app-splitbutton>
				</div>

				<div nz-col nzSpan="8">
					<app-splitbutton [burgerMenu]="true" [elements]="[singleButtonElementPrimaryIcon, singleButtonElementSecondaryIcon]"></app-splitbutton>
				</div>

			</div>
			<nz-divider></nz-divider>
			Splitbutton mit Burgermenü und Icon. Entsteht wenn der Splitbutton über mehr als ein Element verfügt und das erste Element ein Icon hat.
			<nz-divider></nz-divider>
			Optionen:
			<ul>
				<li>
					HTML:<br> <code ngNonBindable>&lt;app-splitbutton [elements]="[singleButtonElementPrimaryIcon, singleButtonElementSecondaryIcon]">&lt;
					/app-splitbutton></code>
				</li>
				<li>
					Komponente:<br> <code ngNonBindable>singleButtonElementPrimaryIcon: SplitButtonElement = &#123;title: 'ui.showcase.primary', type:
					'primary', icon: 'edit'&#125;;</code><br><br>
					<code>singleButtonElementSecondaryIcon: SplitButtonElement = &#123;title: 'ui.showcase.secondary', type:
					'default', icon: 'edit'&#125;;</code>
				</li>
			</ul>
		</nz-card>
	</div>

	<div nz-col nzSpan="12">
		<nz-card nzTitle="{{ 'ui.showcase.pureIcons' | translate }}">
			<div nz-row [nzGutter]="[16, 6]">

				<div nz-col nzSpan="8">
					<app-splitbutton [elements]="[singleButtonElementPrimaryIconOnly]"></app-splitbutton>
				</div>

				<div nz-col nzSpan="8">
					<app-splitbutton [elements]="[singleButtonElementSecondaryIconOnly]"></app-splitbutton>
				</div>

				<div nz-col nzSpan="8">
					<app-splitbutton [burgerMenu]="true" [elements]="[singleButtonElementPrimaryIconOnly]"></app-splitbutton>
				</div>

			</div>
			<nz-divider></nz-divider>
			Button der nur aus einem Icon besteht.
			<nz-divider></nz-divider>
			Optionen:
			<ul>
				<li>
					HTML:<br> <code ngNonBindable>&lt;app-splitbutton [elements]="[singleButtonElementPrimaryIconOnly]">&lt;
					/app-splitbutton></code>
				</li>
				<li>
					Komponente:<br> <code ngNonBindable>singleButtonElementPrimaryIconOnly: SplitButtonElement = &#123;title: 'ui.showcase.primary', type:
					'primary', icon: 'edit', iconOnly: true&#125;;</code>
				</li>
			</ul>
		</nz-card>
	</div>

	<div nz-col nzSpan="12">
		<nz-card nzTitle="Splitbutton disabled">
			<div nz-row [nzGutter]="[16, 6]">

				<div nz-col nzSpan="8">
					<app-splitbutton disabled="true" [elements]="[singleButtonElementPrimaryIcon, singleButtonElementSecondaryIcon]"></app-splitbutton>
				</div>

				<div nz-col nzSpan="8">
					<app-splitbutton disabled="true" [elements]="[singleButtonElementSecondaryIcon, singleButtonElementPrimaryIcon]"></app-splitbutton>
				</div>

				<div nz-col nzSpan="8">
					<app-splitbutton disabled="true" [burgerMenu]="true" [elements]="[singleButtonElementPrimaryIcon, singleButtonElementSecondaryIcon]"></app-splitbutton>
				</div>

			</div>
			<nz-divider></nz-divider>
			Deaktivierter Splitbutton.
			<nz-divider></nz-divider>
			Optionen:
			<ul>
				<li>
					HTML:<br> <code ngNonBindable>&lt;app-splitbutton disabled="true" [elements]="[singleButtonElementPrimaryIcon]">&lt;
					/app-splitbutton></code>
				</li>
			</ul>
		</nz-card>
	</div>

	<div nz-col nzSpan="12">
		<nz-card nzTitle="{{ 'ui.showcase.splitbuttonCallback' | translate }}">
			<div nz-row [nzGutter]="[16, 6]">

				<div nz-col nzSpan="12">
					<app-splitbutton [elements]="[singleButtonElementPrimaryCallback, singleButtonElementSecondaryCallback]"></app-splitbutton>
				</div>

				<div nz-col nzSpan="12">
					<app-splitbutton [burgerMenu]="true" [elements]="[singleButtonElementPrimaryCallback, singleButtonElementSecondaryCallback]"></app-splitbutton>
				</div>

			</div>
			<nz-divider></nz-divider>
			Splitbutton mit Burgermenü und Icon. Buttons verfügen über callback Funktion für Klicks. Dazu wird die zweite Option von der Ersten im Burgermenü
			über eine Horizontale Linie getrennt.
			<nz-divider></nz-divider>
			Optionen:
			<ul>
				<li>
					HTML:<br>
					<code ngNonBindable>
						&lt;app-splitbutton [elements]="[singleButtonElementPrimaryCallback, singleButtonElementSecondaryCallback]">
						&lt;/app-splitbutton>
					</code>
				</li>
				<li>
					Komponente:<br> <code ngNonBindable>singleButtonElementPrimaryCallback: SplitButtonElement = &#123;title: 'ui.showcase.primary', type:
					'primary', icon: 'edit', callback: () => this.testCallBack('Primary')&#125;;</code><br><br>
					<code>singleButtonElementSecondaryCallback: SplitButtonElement = &#123;title: 'ui.showcase.secondary', type:
						'default', icon: 'edit', hasDivider: true, callback: () => this.testCallBack('Secondary')&#125;;</code><br><br>
					<code>public testCallBack(buttonType: string): void &#123; console.log(buttonType + ' Button click!'); &#125;</code>
				</li>
			</ul>
		</nz-card>
	</div>

	<div nz-col nzSpan="12">
		<nz-card nzTitle="Splitbutton in Übergröße">
			<div nz-row [nzGutter]="[16, 6]">

				<div nz-col nzSpan="12">
					<app-splitbutton class="big-button" [elements]="[singleButtonElementPrimaryIcon, singleButtonElementSecondaryIcon]"></app-splitbutton>
				</div>

				<div nz-col nzSpan="12">
					<app-splitbutton class="big-button" [burgerMenu]="true" [elements]="[singleButtonElementPrimaryIcon, singleButtonElementSecondaryIcon]"></app-splitbutton>
				</div>

			</div>
			<nz-divider></nz-divider>
			Splitbutton in Übergröße z.B. für Wizard.
			<nz-divider></nz-divider>
			Optionen:
			<ul>
				<li>
					HTML:<br>
					<code ngNonBindable>
						&lt;app-splitbutton class="big-button" [elements]="[singleButtonElementPrimaryIcon, singleButtonElementSecondaryIcon]">
						&lt;/app-splitbutton>
					</code>
				</li>
			</ul>
		</nz-card>
	</div>

</div>
